import React, { useState } from "react";
// components
import AnimatedLottie from "../components/Lottie";
import TechSkillIcon from "../components/skills/TechIcon";
import ListItem from "../components/skills/ListItem";
import HeadingAnimate from "../components/animate/HeadingAnimate";
import LoadAnimate from "../components/animate/LoadAnimate";
// mock
import {
  BACKEND_DESCRIPTIONS,
  BACKEND_SKILLS,
  FRONTEND_DESCRIPTIONS,
  FRONTEND_SKILLS,
  GAME_DESCRIPTIONS,
  GAME_SKILLS,
  BLOCKCHAIN_DESCRIPTIONS,
  BLOCKCHAIN_SKILLS,
  SkillTABS,
} from "../mock/tech-skills";
import codingAnimationData from "../mock/lottie/coding.json";
import cloudAnimationData from "../mock/lottie/cloudinfra.json";
import gameAnimationData from "../mock/lottie/game.json";
import fullstackAnimationData from "../mock/lottie/fullstack.json";

// ----------------------------------------------------------------------

export default function Skills() {
  const [currentTab, setCurrentTab] = useState(0);

  const activeClass =
    "inline-flex justify-center border-[1px] border-solid min-w-fit w-[250px] h-[47px] sm:h-[65px] text-[17px] sm:text-[22px] font-bold sm:mr-[30px] leading-9 items-center space-x-4 p-4 text-[#ffe600] rounded-[38px] active dark:text-[#ffe600]  transition-all duration-75 group";

  const handleOnClick = (_value) => {
    setCurrentTab(_value);
  };

  return (
    <>
      <div id="skills" />
      <div className="bg-[#222121] py-14">
        <section className="container mx-auto mt-12 text-center sm:mt-20 my-11">
          <HeadingAnimate>
            <h2 className=" mb-5 font-lato text-3xl font-semibold text-primary-700 dark:text-cyan-400 sm:text-5xl">
              SKILLS AND EXPERTISE
            </h2>
          </HeadingAnimate>

          <LoadAnimate amount={0}>
            <div className="container mx-auto my-5 flex flex-col items-center p-5 md:flex-col">
              <ul
                id="works-tab"
                className="sm:mb-16 flex max-w-full gap-x-2 font-medium  hover:cursor-pointer"
              >
                {SkillTABS.map((tab, i) => (
                  <li
                    key={`tab ${i}`}
                    onClick={() => handleOnClick(tab.value)}
                    className={
                      currentTab === tab.value
                        ? activeClass
                        : "group inline-flex justify-center w-[220px] sm:w-[250px] h-[47px] sm:h-[65px] text-[17px] sm:text-[22px] font-bold mx-auto sm:mr-[30px] leading-9 border-2 border-solid rounded-[38px] border-[#373737] bg-[#373737] text-white items-center space-x-4 border-b-2 border-transparent p-4 transition-all duration-75"
                    }
                  >
                    <span>{tab.label}</span>
                  </li>
                ))}
              </ul>

              {/* Frontend Development */}
              {currentTab == 0 && (
                <LoadAnimate amount={0}>
                  <div className="container mx-auto my-5 flex flex-col items-center p-5 md:flex-row lg:min-w-[1100px]">
                    <div className="flex flex-col items-center text-center md:w-1/2 md:items-start md:pl-16 md:text-left lg:flex-grow lg:pl-24">
                      <HeadingAnimate>
                        <h1 className="mb-4 text-xl font-semibold tracking-wide text-primary-700 dark:text-primary-300 sm:text-2xl">
                          Frontend Development
                        </h1>
                      </HeadingAnimate>
                      {/* Tech Stack  */}
                      <div className="my-3 flex flex-wrap justify-items-center gap-x-4 gap-y-7 text-center sm:gap-x-7">
                        {FRONTEND_SKILLS.map(
                          ({ label, icon, proficiency, iconClasses }, i) => (
                            <TechSkillIcon
                              key={`frontend-skill-${i}`}
                              popoverId={`frontend-skill-${i}`}
                              icon={icon}
                              iconClasses={iconClasses}
                              label={label}
                              proficiency={proficiency}
                            />
                          )
                        )}
                      </div>
                      {/* Description Part  */}
                      <div className="mt-7 w-full space-y-3">
                        {FRONTEND_DESCRIPTIONS.map((paragraph, i) => (
                          <ListItem
                            key={`frontend-des-${i}`}
                            paragraph={paragraph}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </LoadAnimate>
              )}
              {/* Backend Development */}
              {currentTab == 1 && (
                <LoadAnimate amount={0}>
                  <div className="container mx-auto my-5 flex flex-col items-center p-5 md:flex-row-reverse  lg:min-w-[1100px]">
                    <div className="flex flex-col items-center text-center md:w-1/2 md:items-start md:pl-16 md:text-left lg:flex-grow lg:pl-24">
                      <HeadingAnimate>
                        <h1 className="mb-4 text-xl font-semibold tracking-wide text-primary-700 dark:text-primary-300 sm:text-2xl">
                          Backend Development
                        </h1>
                      </HeadingAnimate>
                      {/* Tech Stack  */}
                      <div className="my-3 flex flex-wrap justify-items-center gap-x-4 gap-y-7 text-center sm:gap-x-7">
                        {BACKEND_SKILLS.map(
                          ({ icon, iconClasses, label, proficiency }, i) => (
                            <TechSkillIcon
                              key={`backend-skill-${i}`}
                              popoverId={`backend-skill-${i}`}
                              icon={icon}
                              iconClasses={iconClasses}
                              label={label}
                              proficiency={proficiency}
                            />
                          )
                        )}
                      </div>
                      {/* Description Part  */}
                      <div className="mt-5 w-full space-y-3 sm:mt-7">
                        {BACKEND_DESCRIPTIONS.map((paragraph, i) => (
                          <ListItem
                            key={`backend-des-${i}`}
                            paragraph={paragraph}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </LoadAnimate>
              )}
              {/* Blockchain Development */}
              {currentTab == 2 && (
                <LoadAnimate amount={0}>
                  <div className="container mx-auto my-5 flex flex-col items-center p-5 md:flex-row lg:min-w-[1100px]">
                    <div className="flex flex-col items-center text-center md:w-1/2 md:items-start md:pl-16 md:text-left lg:flex-grow lg:pl-24">
                      <HeadingAnimate>
                        <h1 className="mb-4 text-xl font-semibold tracking-wide text-primary-700 dark:text-primary-300 sm:text-2xl">
                          Blockchain Development
                        </h1>
                      </HeadingAnimate>
                      {/* Tech Stack  */}
                      <div className="my-3 flex flex-wrap justify-items-center gap-x-4 gap-y-7 text-center sm:gap-x-7">
                        {BLOCKCHAIN_SKILLS.map(
                          ({ icon, iconClasses, label, proficiency }, i) => (
                            <TechSkillIcon
                              key={`backend-skill-${i}`}
                              popoverId={`backend-skill-${i}`}
                              icon={icon}
                              iconClasses={iconClasses}
                              label={label}
                              proficiency={proficiency}
                            />
                          )
                        )}
                      </div>
                      {/* Description Part  */}
                      <div className="mt-5 w-full space-y-3 sm:mt-7">
                        {BLOCKCHAIN_DESCRIPTIONS.map((paragraph, i) => (
                          <ListItem
                            key={`backend-des-${i}`}
                            paragraph={paragraph}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </LoadAnimate>
              )}
            </div>
          </LoadAnimate>
        </section>
      </div>
    </>
  );
}
